import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AdminState {
  isAuthenticated: boolean;
  adminToken: string | null;

  // Actions
  login: (token: string) => void;
  logout: () => void;
}

export const useAdminStore = create<AdminState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      adminToken: null,

      login: (token: string) => {
        set({
          isAuthenticated: true,
          adminToken: token,
        });
      },

      logout: () => {
        set({
          isAuthenticated: false,
          adminToken: null,
        });
        localStorage.removeItem('sweetpilot-admin');
      },
    }),
    {
      name: 'sweetpilot-admin',
      partialize: (state) => ({
        adminToken: state.adminToken,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
